import { Record } from 'immutable';
import { MONTHLY } from 'commons-vehicle/PurchaseMethods/constants/paymentFrequencies.js';

const PaymentFrequencyRecord = Record({
    paymentFrequency: MONTHLY,
    payment: 0,
    paymentTaxes: 0,
    financeFactor: 0,
    balloonFactor: 0,
    cashDownPaymentAdjustment: 0,
    netTradeInPaymentAdjustment: 0,
    netTradeInPaymentTaxesAdjustment: 0,
    calculatedNetPayment: 0,
    calculatedPayment: 0,
    disclaimers: [],
});

class PaymentFrequency extends PaymentFrequencyRecord {
    getSelectionCode() {
        return this.get('selectionCode');
    }
}

export default PaymentFrequency;
